<template>
    <div class="container py-5">
      <h1 class="mb-4">My Tickets</h1>

      <!-- <code><pre>{{ JSON.stringify(transactions, null, 2) }}</pre></code> -->
      
      <div class="row">
        <div class="col-md-12 mb-4" v-for="ticket in transactions" :key="ticket.id">
          <ticket-card
            :ticket="ticket"
            @click="showTicketDetails(ticket)"
          />
        </div>
      </div>
  
      <ticket-details
        v-if="selectedTicket"
        :ticket="selectedTicket"
        @close="closeTicketDetails"
      />
    </div>
  </template>
  
  <script>
  import TicketDetails from './TicketDetails.vue'
  import TicketCard from './TicketCard.vue'
  
  export default {
    name: 'TicketList',
    components: {
      TicketDetails,
      TicketCard
    },
    props: {
      transactions: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        selectedTicket: null
      }
    },
    methods: {
      showTicketDetails(ticket) {
        this.selectedTicket = ticket
      },
      closeTicketDetails() {
        this.selectedTicket = null
      }
    }
  }
  </script>